import {
	Component,
	ViewEncapsulation,
	Input,
	EventEmitter,
	Output,
	OnInit,
	OnDestroy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { LocationService } from '../../services/location.service';
import { PageHeaderSearchResultsRow } from '../../models/page-header-search-results-row';

@Component({
	selector: 'copo-panel-header',
	templateUrl: './page-header.component.html',
	styleUrl: './page-header.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,

		MatButtonModule,
		MatIconModule,
		TranslateModule,
	],
})
export class PageHeaderComponent implements OnInit, OnDestroy {
	/**
	 * Delay between executing request while user is still typing.
	 * Please provide values in milliseconds.
	 */
	@Input() searchDelay = 350;

	/**
	 * Sets page title.
	 */
	@Input() titleHeaderText = '';

	/**
	 * Second part of header, ie. mainHeaderText - pathHeaderText.
	 */
	@Input() pathHeaderText = '';

	/**
	 * Third part of header, ie. mainHeaderText - pathHeaderText - detailsHeaderText.
	 */
	@Input() detailsHeaderText = '';
	@Input() headerTextSeparator = ' - ';

	@Input() searchPanelPlaceholder = '';
	@Input() minSearchQueryLength = 3;
	@Input() searchResults: PageHeaderSearchResultsRow[] = [];
	@Output() readonly searchValueChange = new EventEmitter<string>();
	@Output() readonly searchResultsRowClick = new EventEmitter<string>();

	@Input() isBackButtonVisible = true;
	@Output() readonly backButtonClick = new EventEmitter<string>();

	searchControl = new FormControl();

	private readonly subscription = new Subscription();

	constructor(readonly locationService: LocationService) {}

	ngOnInit() {
		const sub = this.searchControl.valueChanges
			.pipe(debounceTime(this.searchDelay), distinctUntilChanged())
			.subscribe({
				next: (value: string) => {
					if (value.length >= this.minSearchQueryLength) {
						this.searchValueChange.emit(value);
					} else {
						this.searchResults = [];
					}
				},
			});

		this.subscription.add(sub);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onBackButtonClicked() {
		this.backButtonClick.emit();
	}

	onQuickSearchRowClick(id: string) {
		this.searchResultsRowClick.emit(id);
	}
}
